exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uucontentkit-table-cell-text-input{min-height:22px;margin:-6px -16px;padding-left:16px}.uucontentkit-table-cell-text-input .button-open-modal{position:absolute;bottom:0;right:8px;z-index:999;background-color:transparent}.uucontentkit-table-cell-text-input .button-open-modal:hover{background-color:transparent}.uucontentkit-table-cell-text-input .testdiv{position:relative;background-color:#fff;outline-offset:0;outline:1px solid #e0e0e0!important;min-height:32px;padding:4px 8px;margin-left:-8px;margin-right:8px}.uucontentkit-table-cell-text-input .div-uu5stringeditor{margin-left:-16px;position:relative}.uucontentkit-table-cell-text-input .div-uu5stringeditor.div-uu5stringeditor-focused .ace_editor{outline:1px solid #2196f3!important;border:0!important}.uucontentkit-table-cell-text-input .div-uu5stringeditor .uu5-codekit-code-editor{margin-top:0;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"minimize":true}!../node_modules/postcss-loader/lib?{"plugins":[null]}!../node_modules/less-loader/dist/cjs.js!./bricks/table-cell-text-input.less
// module id = 16
// module chunks = 0